/**
 * OMS fulfillment-type code mapping.
 *
 * Lives in a util rather than in `OrderTrackingDetails` so importing it does not
 * pull that component's graph (`@delivery/tracking`, `sui-icons`, `ShippingAddress`,
 * …) into modules that only need a string lookup — `SingleStartAReturn` renders on
 * the guest order-tracking route, where that weight is pure cost.
 *
 * `OrderTrackingDetails` re-exports both for backwards compatibility, so existing
 * importers keep working; new code should import from here.
 *
 * Note OMS spells deliver-from-store two ways (`DFS` and `DeliverFromStore`) and
 * both fold to `dfs`. Always compare on the coded form — a raw equality check
 * against one spelling silently misses the other.
 */
export const convertedFulfillmentTypes = (type: string) => {
  return {
    APPLIANCE: 'ma',
    Appliance: 'ma',
    BuyOnlineDeliverFromStore: 'bodfs',
    DeliverFromStore: 'dfs',
    DFS: 'dfs',
    ShipToHome: 'sth',
    BuyOnlineShipToStore: 'boss',
    BuyOnlinePickupInStore: 'bopis',
    MISC: 'misc',
  }[type];
};

/**
 * Uppercased fulfillment code (e.g. `STH`, `BODFS`) or `undefined` — the shape
 * used for New Relic instrumentation attributes and cart requests.
 */
export const fulfillmentCode = (type?: string): string | undefined =>
  convertedFulfillmentTypes(type ?? '')?.toUpperCase() || undefined;
